<ng-container *ngIf="state$ | async; let state">
    <ng-container *ngIf="createViewState(state); let view">
        <ng-container *ngIf="validity$ | async; let validity">
            <attachments
                [attachmentAvailable]="state.cp.AttachmentAvailable"
                [attachments]="state.protocol.Attachments"
                [addAttachmentFun]="addAttachment(state.protocol)"
            ></attachments>
            <div *ngIf="state.cp.Application !== 'WebLife'" class="zas-row">
                <zbd-input
                    type="checkbox"
                    name="acceptAll"
                    class="zas-main-col"
                    label="Alle Angebote stimmen mit der Empfehlung überein und werden vom Kunden angenommen"
                    [value]="getAcceptAllState(state.protocol)"
                    (value-change)="acceptAll(state.protocol, $event)"
                ></zbd-input>
            </div>
            <!--<div class="zas-row">
    <div class="form-group zas-inner-col-left">
        <input class="form-control" type="checkbox" id="offerPerLink" [(ngModel)]="allViaLink" />
        <label for="offerPerLink">Kunde erhält alle Angebote per Link</label>
    </div>
</div>-->

            <div class="zas-row">
                <div class="zas-main-col">
                    <zbd-input
                        type="textarea"
                        label="Manuelle Ergänzung"
                        [rows]="1"
                        [focused-rows]="5"
                        [autogrow]="true"
                        [entity]="state.protocol"
                        property="ManualAddition"
                        [updateFn]="persistence.updateProtocol"
                        [securityFilter]="'light'"
                    ></zbd-input>
                </div>
            </div>

            <div
                class="zas-row"
                *ngIf="
                    state.cp.Application === null && manualOffer$ | async;
                    let manualOffer
                "
            >
                <div class="zas-main-col">
                    <div class="input-with-info">
                        <zbd-info
                            style="
                                float: right;
                                position: relative;
                                right: 0;
                                z-index: 1;
                            "
                        >
                            Gemeint ist hiermit die Vorschlags-/Angebots- oder
                            Antragsnummer, wie sie im Tarifrechner nach der
                            Speicherung angezeigt wird. Sofern die
                            Beratungsdokumentation manuell, also nicht über
                            einen Tarifrechner, angelegt wurde, können Sie hier
                            die entsprechende "Vorgangsnummer" eintragen, auf
                            welche sich das Beratungsgespräch bezieht. Diese
                            Vorgangsnummer wird dann in der
                            Beratungsdokumentation unter "Angebotswunsch" sowie
                            unter "Entscheidung" neben der Produktbezeichnung
                            angedruckt. Es kann immer nur eine Nummer
                            eingetragen werden, daher können jeweils nur die
                            Produkte dokumentiert werden, die dieser Nummer
                            zuzuordnen sind. Wurden mehrere Produkte mit
                            unterschiedlichen Nummern beraten, so füllen Sie
                            bitte zu jeder Vorgangsnummer eine separate
                            Dokumentation aus.
                        </zbd-info>
                        <zbd-input
                            type="text"
                            label="Vorgangsnummer"
                            [entity]="manualOffer"
                            property="ExternalId"
                            [updateFn]="persistence.updateOffer"
                        ></zbd-input>
                    </div>
                </div>
                <div class="zas-main-col"></div>
            </div>

            <div class="zas-row">
                <div *ngFor="let category of categories" class="zas-main-col">
                    <label
                        (click)="selectCategory(category, state.protocol)"
                        [ngClass]="{
                            'zbd-text-button-selected ':
                                selectedCategory === category,
                            'zbd-text-button': selectedCategory !== category,
                        }"
                    >
                        {{ category.name.displayName }}
                    </label>
                </div>
            </div>

            <hr />

            <zbd-tabbar
                (select)="onTabSelected($event, state.protocol)"
                appearance="selector-strip"
            >
                <zbd-tab
                    *ngFor="let line of view.lines; trackBy: trackByLine"
                    [tabTitle]="line.displayName"
                    [active]="line === selectedLine"
                    [isValid]="validity.lines[line.key]?.valid"
                >
                    <zbd-simple-toggle
                        #toggleable
                        [title]="'Kundenbedarf'"
                        [isValid]="validity.lines[line.key]?.demand.valid"
                        [isValidateable]="true"
                        [isOpen]="false"
                        (opened)="onToggleableOpened($event)"
                    >
                        <ng-container
                            *ngFor="
                                let division of view.divisionDemands;
                                let index = index;
                                trackBy: trackEntity
                            "
                        >
                            <zbd-demand
                                *ngIf="validity.divisions[division.Id]"
                                [persistence]="persistence"
                                [division]="division"
                                [validity]="validity.demands[division.Id]"
                            ></zbd-demand>
                            <div class="zas-row">
                                <div class="zas-main-col">
                                    <hr
                                        *ngIf="
                                            index < view.divisions.length - 1
                                        "
                                    />
                                </div>
                            </div>
                        </ng-container>
                    </zbd-simple-toggle>
                    <zbd-simple-toggle
                        #toggleable
                        [title]="'Empfehlung und Begründung'"
                        [isValid]="
                            validity.lines[line.key]?.recommendation.valid
                        "
                        [isValidateable]="true"
                        [isOpen]="false"
                        (opened)="onToggleableOpened($event)"
                    >
                        <ng-container
                            *ngFor="
                                let division of view.divisions;
                                let index = index;
                                trackBy: trackEntity
                            "
                        >
                            <zbd-recommendation
                                *ngIf="validity.divisions[division.Id]"
                                [persistence]="persistence"
                                [division]="division"
                                [validity]="validity.divisions[division.Id]"
                            ></zbd-recommendation>
                            <div class="zas-row">
                                <div class="zas-main-col">
                                    <hr
                                        *ngIf="
                                            index < view.divisions.length - 1
                                        "
                                    />
                                </div>
                            </div>
                        </ng-container>
                    </zbd-simple-toggle>
                    <zbd-simple-toggle
                        #toggleable
                        [title]="'Angebotswunsch und Kundenentscheidung'"
                        [isValid]="validity.lines[line.key]?.decision.valid"
                        [isValidateable]="true"
                        [isOpen]="false"
                        (opened)="onToggleableOpened($event)"
                    >
                        <ng-container
                            *ngFor="
                                let division of view.divisions;
                                let index = index;
                                trackBy: trackEntity
                            "
                        >
                            <zbd-decision
                                *ngIf="validity.divisions[division.Id]"
                                [persistence]="persistence"
                                [division]="division"
                                [validity]="validity.divisions[division.Id]"
                            ></zbd-decision>
                            <div class="zas-row">
                                <div class="zas-main-col">
                                    <hr
                                        *ngIf="
                                            index < view.divisions.length - 1
                                        "
                                    />
                                </div>
                            </div>
                        </ng-container>
                    </zbd-simple-toggle>
                </zbd-tab>
            </zbd-tabbar>
        </ng-container>
    </ng-container>
</ng-container>
